<script>
import { authComputed } from '@state/helpers'
import Report from '@components/reportrequest'
import {
  ADMIN_ROLE,
  COLLEGE_ROLE,
  TEACHER_ROLE,
  ADMINISTRATOR_ROLE,
  HOD_ROLE,
} from '@utils/constant'

export default {
  components: {
    Report: Report,
  },
  props: {
    user: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      COLLEGE_ROLE: COLLEGE_ROLE,
      ADMIN_ROLE: ADMIN_ROLE,
      TEACHER_ROLE: TEACHER_ROLE,
      ADMINISTRATOR_ROLE: ADMINISTRATOR_ROLE,
      HOD_ROLE: HOD_ROLE,
      active: 0,
      activeClass: 'active',
    }
  },
  computed: {
    ...authComputed,
  },
  // mounted: function() {
  //   // eslint-disable-next-line no-unused-vars
  //   var menuRef = new MetisMenu('#side-menu')
  // },
  methods: {
    getrequest() {
      this.active = 1
    },

    // get current path
    getCurrentPath(path) {
      return this.$route.path.includes(path)
    },
  },
}
</script>

<template>
  <div>
    <!--- Sidemenu -->
    <div id="sidebar-menu">
      <ul id="side-menu" class="metismenu topmenu">
        <li class="menu-title">NAVIGATION MENU</li>
        <li>
          <router-link tag="a" to="/" title="View User, Course related Reports">
            <i class="mdi mdi-view-dashboard"></i>
            <span>Dashboard</span>
          </router-link>
        </li>
        <li v-if="role === ADMIN_ROLE">
          <router-link tag="a" to="/admin-list" title="View and Add Admins">
            <i class="mdi mdi-account-multiple"></i>
            <span>Manage Admins</span>
          </router-link>
        </li>
        <li v-if="role !== TEACHER_ROLE" class="colleges-section">
          <router-link
            tag="a"
            to="#college"
            title="View/Add Colleges, Departments, Classes and Teachers"
            style="pointer-events:none;"
          >
            <i class="mdi mdi-account-multiple"></i>
            <span>College</span><i class="fas fa-caret-down"></i>
          </router-link>
        </li>
        <div class="colleges-dropdown">
          <li v-if="role === ADMINISTRATOR_ROLE || role === ADMIN_ROLE">
            <router-link tag="a" to="/college-list" title="View/Add Colleges">
              <i class="mdi mdi-account-multiple"></i>
              <span>Manage Colleges</span>
            </router-link>
          </li>
          <li
            v-if="
              role === COLLEGE_ROLE ||
                role === ADMINISTRATOR_ROLE ||
                role === ADMIN_ROLE
            "
          >
            <router-link
              tag="a"
              to="/department-list"
              title="View/Add College Departments"
            >
              <i class="mdi mdi-account-multiple"></i>
              <span>Manage Departments</span>
            </router-link>
          </li>
          <li
            v-if="
              role === COLLEGE_ROLE ||
                role === ADMINISTRATOR_ROLE ||
                role === HOD_ROLE ||
                role === ADMIN_ROLE
            "
          >
            <router-link
              tag="a"
              to="/college-class-list"
              title="View/Add College Classes"
            >
              <i class="mdi mdi-account-multiple"></i>
              <span>Manage Classes</span>
            </router-link>
          </li>
          <li
            v-if="
              role === COLLEGE_ROLE ||
                role === ADMINISTRATOR_ROLE ||
                role === ADMIN_ROLE
            "
          >
            <router-link
              tag="a"
              to="/teacher-list"
              title="View/Add HOD/Teachers"
            >
              <i class="mdi mdi-account-multiple"></i>
              <span>Manage HOD/Teachers</span>
            </router-link>
          </li>
          <li v-if="role === HOD_ROLE">
            <router-link tag="a" to="/teacher-list" title="View/Add Teachers">
              <i class="mdi mdi-account-multiple"></i>
              <span>Manage Teachers</span>
            </router-link>
          </li>
        </div>
        <li class="students-section">
          <router-link
            tag="a"
            to="#students"
            title="View/Add Students"
            style="pointer-events:none;"
          >
            <i class="mdi mdi-account-multiple"></i>
            <span>Students</span><i class="fas fa-caret-down"></i>
          </router-link>
        </li>
        <div class="students-dropdown">
          <li
            v-if="
              role === COLLEGE_ROLE ||
                role === ADMINISTRATOR_ROLE ||
                role === ADMIN_ROLE
            "
          >
            <router-link
              tag="a"
              to="/student-list"
              title="View/Add Registered Students"
            >
              <i class="mdi mdi-account-multiple"></i>
              <span>Invited Students</span>
            </router-link>
          </li>
          <li>
            <router-link
              tag="a"
              to="/user-list"
              title="View/Add Enrolled Students"
            >
              <i class="mdi mdi-account-multiple"></i>
              <span>Manage Students</span>
            </router-link>
          </li>
        </div>
        <li
          v-if="role !== HOD_ROLE && role !== TEACHER_ROLE"
          class="categories-section"
        >
          <router-link
            tag="a"
            to="#categories"
            title="View/Add Categories and Subcategories"
            style="pointer-events:none;"
          >
            <i class="mdi mdi-book-multiple"></i>
            <span>Categories</span><i class="fas fa-caret-down"></i>
          </router-link>
        </li>
        <div class="categories-dropdown">
          <li
            v-if="
              role === COLLEGE_ROLE ||
                role === ADMINISTRATOR_ROLE ||
                role === ADMIN_ROLE
            "
          >
            <router-link
              tag="a"
              to="/category-list"
              title="View/Add Categories"
            >
              <i class="mdi mdi-book-multiple"></i>
              <span>Manage Categories</span>
            </router-link>
          </li>
          <li
            v-if="
              role === COLLEGE_ROLE ||
                role === ADMINISTRATOR_ROLE ||
                role === ADMIN_ROLE
            "
          >
            <router-link
              tag="a"
              to="/subcategory-list"
              title="View/Add Sub Categories"
            >
              <i class="mdi mdi-book-multiple"></i>
              <span>Manage Sub Categories</span>
            </router-link>
          </li>
        </div>
        <li>
          <router-link tag="a" to="/course-list" title="View/Add Courses">
            <i class="mdi mdi-book-multiple"></i>
            <span>Manage Courses</span>
          </router-link>
        </li>
        <li>
          <router-link tag="a" to="/event-list" title="View/Add Events">
            <i class="mdi mdi-calendar-clock"></i>
            <span>Manage Events</span>
          </router-link>
        </li>
        <li>
          <router-link tag="a" to="/blog-list" title="View/Add Blogs">
            <i class="mdi mdi-file-document-box"></i>
            <span>Manage Blogs</span>
          </router-link>
        </li>
        <li
          v-if="
            role === COLLEGE_ROLE || role === TEACHER_ROLE || role === HOD_ROLE
          "
        >
          <router-link tag="a" to="/meeting-list" title="View/Add Live Classes">
            <i class="mdi mdi-video"></i>
            <span>Manage Live Class</span>
          </router-link>
        </li>
        <li
          v-if="
            role === COLLEGE_ROLE || role === TEACHER_ROLE || role === HOD_ROLE
          "
        >
          <router-link
            tag="a"
            to="/calendar"
            title="Access and manage daily time table"
          >
            <i class="mdi mdi-calendar-today"></i>
            <span>Calendar</span>
          </router-link>
        </li>
        <li>
          <router-link
            tag="a"
            to="/resource-list"
            title="View/Add Course Resources"
          >
            <i class="mdi mdi-file-document"></i>
            <span>Manage Resources</span>
          </router-link>
        </li>
        <li>
          <router-link
            tag="a"
            to="/assignment-list"
            title="View/Add Course Assignments"
          >
            <i class="mdi mdi-pencil"></i>
            <span>Manage Assignments</span>
          </router-link>
        </li>
        <li
          v-if="
            role === COLLEGE_ROLE ||
              role === ADMINISTRATOR_ROLE ||
              role === ADMIN_ROLE
          "
        >
          <router-link
            tag="a"
            to="/report-list"
            title="View Course, Users Reports"
          >
            <i class="mdi mdi-book-open"></i>
            <span>Reports</span>
          </router-link>
        </li>
        <li v-if="role === COLLEGE_ROLE || role === ADMINISTRATOR_ROLE">
          <b-button
            v-b-modal="'my-modal1'"
            style="margin-left:20px;"
            @click="getrequest"
            >Request Report</b-button
          >
          <Report v-if="active"></Report>
        </li>
      </ul>
      <div class="clearfix"></div>
    </div>
    <!-- End Sidebar -->
  </div>
</template>

<style lang="scss">
@import '~metismenujs/scss/metismenujs';
.topmenu .router-link-exact-active {
  color: #71b6f9 !important;
}
.students-dropdown,
.categories-dropdown,
.colleges-dropdown {
  display: none;
  background: #f2f6f9;
}
.students-dropdown:hover,
.categories-dropdown:hover,
.colleges-dropdown:hover,
.students-dropdown:active,
.categories-dropdown:active,
.colleges-dropdown:active,
.students-dropdown:focus,
.categories-dropdown:focus,
.colleges-dropdown:focus {
  display: block !important;
}
.students-section:hover,
.categories-section:hover,
.colleges-section:hover {
  color: black !important;
}
.students-section:hover + .students-dropdown,
.categories-section:hover + .categories-dropdown,
.colleges-section:hover + .colleges-dropdown {
  display: block !important;
}
.students-dropdown a,
.categories-dropdown a,
.colleges-dropdown a {
  position: relative;
  display: block;
  padding: 13px 20px;
  font-size: 0.925rem;
  color: black;
  -webkit-transition: all 0.4s;
  transition: all 0.4s;
}

.students-dropdown a i,
.categories-dropdown a i,
.colleges-dropdown a i {
  display: inline-block;
  width: 20px;
  margin: 0 10px 0 3px;
  line-height: 1.0625rem;
  text-align: center;
  vertical-align: middle;
}
</style>
